type Props = {
  children: React.ReactNode;
};
const FilterCount: React.FC<Props> = ({ children }) => {
  return (
    <span className="flex size-[18px] items-center justify-center rounded-full bg-neutrals-black text-[12px] font-medium text-white">
      {children}
    </span>
  );
};

export default FilterCount;
